import { Fragment } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import {
  Box,
  FormControlLabel,
  FormHelperText,
  Grid,
  Radio,
  RadioGroup,
  Switch,
} from '@material-ui/core'

import { Label, Select } from 'components'
import { PlatformDiscountFields } from './components'

import PropTypes from 'prop-types'

import theme from 'theme'
import constants from 'constants/index'

const BenefitsSection = ({
  hasBenefits,
  setHasBenefits,
  show,
  platformServicePrice,
  contractPrice,
}) => {
  const { control, errors, watch } = useFormContext()

  const benefits = watch('benefits')

  const isDiscount = benefits === 'discount'
  const isFreeMonthlyFee = benefits === 'freeMonthlyFee'

  const handleChangeSwitch = (event) => setHasBenefits(event?.target?.checked)

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormControlLabel
          label="Conceder benefícios"
          control={
            <Switch
              color="primary"
              checked={hasBenefits}
              onChange={handleChangeSwitch}
              disabled={show}
            />
          }
          name="hasBenefits"
        />
      </Grid>
      {hasBenefits && (
        <Fragment>
          <Grid item xs={12}>
            <Controller
              as={
                <RadioGroup>
                  <Label title="Benefícios concedidos" />
                  <Box display="flex" gridGap={theme.spacing(2)}>
                    <FormControlLabel
                      label="Desconto na mensalidade"
                      value="discount"
                      control={<Radio color="primary" />}
                      disabled={show}
                    />
                    <FormControlLabel
                      label="Gratuidade na mensalidade"
                      value="freeMonthlyFee"
                      control={<Radio color="primary" />}
                      disabled={show}
                    />
                  </Box>
                </RadioGroup>
              }
              control={control}
              name="benefits"
            />
            {!!errors?.benefits && (
              <FormHelperText error={!!errors?.benefits}>
                {errors?.benefits?.message}
              </FormHelperText>
            )}
          </Grid>
          {isDiscount && (
            <PlatformDiscountFields
              platformServicePrice={platformServicePrice}
              contractPrice={contractPrice}
              show={show}
            />
          )}
          {isFreeMonthlyFee && (
            <Grid item xs={12} md={3}>
              <Controller
                as={
                  <Select
                    items={constants.churn.QUANTITY_MONTHS_ITEMS}
                    label="Quantidade meses"
                    variant="outlined"
                    error={!!errors?.gratuity}
                    helperText={<>{errors?.gratuity?.message}</>}
                    fullWidth
                    disabled={show}
                  />
                }
                control={control}
                name="gratuity"
                mode="onChange"
              />
            </Grid>
          )}
        </Fragment>
      )}
    </Grid>
  )
}

BenefitsSection.propTypes = {
  hasBenefits: PropTypes.bool,
  setHasBenefits: PropTypes.func,
  show: PropTypes.bool,
  platformServicePrice: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  contractPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default BenefitsSection
